/* DURVA — Festive '26 template interactions (guarded against double-load) */
(function () {
  if (window.__dvInit) return;
  window.__dvInit = true;

  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    // cover entrance
    var cover = document.querySelector('.dv-cover');
    if (cover) {
      if (rm) cover.classList.add('dv-ready');
      else setTimeout(function () { cover.classList.add('dv-ready'); }, 200);
    }

    // header: hidden while the first fold (cover) is on screen; once the fold
    // is scrolled past, it stays pinned to the top in both scroll directions
    if (document.documentElement.classList.contains('dv-veil')) {
      var headShown = false;
      var coverEl = document.querySelector('.dv-cover');
      var setHead = function (s) {
        if (s === headShown) return;
        headShown = s;
        document.documentElement.classList.toggle('dv-headin', s);
        document.documentElement.classList.toggle('dv-veil', !s);
      };
      var judgeFold = function () {
        var past = coverEl
          ? coverEl.getBoundingClientRect().bottom <= 0
          : window.scrollY >= window.innerHeight;
        setHead(past);
      };
      window.addEventListener('scroll', judgeFold, { passive: true });
      judgeFold();
    }

    // scroll reveals
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dv-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14 });
    document.querySelectorAll('.dv-reveal, .dv-look, .dv-collage, .dv-ritual').forEach(function (el) { io.observe(el); });

    // ritual colours: pinned scroll story — intro, then one line in the spotlight
    // per scroll beat, then the finale lights the whole palette
    var rsec = document.querySelector('.dv-ritualc');
    var rstage = rsec ? rsec.querySelector('.dv-rc-stage') : null;
    if (rsec && rstage && !rm) {
      var rpin = rsec.querySelector('.dv-rc-pin');
      var lines = rsec.querySelectorAll('.dv-rline');
      var bloom = rsec.querySelector('.dv-bloom');
      var beats = lines.length + 1; /* stage items + finale */
      var lastBeat = -1;
      var fireBloom = function (c) {
        if (!bloom) return;
        bloom.style.background = 'radial-gradient(circle, ' + c + '66 0%, ' + c + '22 34%, transparent 62%)';
        bloom.classList.remove('dv-go');
        void bloom.offsetWidth;
        bloom.classList.add('dv-go');
      };
      var setBeat = function (b) {
        if (b === lastBeat) return;
        lastBeat = b;
        rsec.classList.toggle('dv-finale', b >= beats - 1);
        var tint = '#f8f5ef';
        lines.forEach(function (l, i) {
          var current = (b === i);
          l.classList.toggle('dv-current', current);
          if (current) {
            tint = l.getAttribute('data-tint') || tint;
            fireBloom(l.getAttribute('data-colour') || '#655122');
          }
        });
        if (rpin) rpin.style.backgroundColor = tint;
      };
      var rawB = 0, curB = 0, storyRunning = false, storyMove = 0;
      var measureStory = function () {
        var r = rstage.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        if (total <= 0) return;
        rawB = Math.min(0.999, Math.max(0, -r.top / total)) * beats;
      };
      var frames = rsec.querySelectorAll('.dv-rc-frame');
      /* washes: ivory → one strong colour per line → ivory; interpolated per frame */
      var hex2rgb = function (h) {
        h = (h || '#f8f5ef').replace('#', '');
        return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)];
      };
      var washes = [];
      lines.forEach(function (l) { washes.push(hex2rgb(l.getAttribute('data-tint'))); });
      washes.push(hex2rgb('#f8f5ef'));
      var applyStory = function (b) {
        setBeat(Math.floor(b));
        var finale = Math.floor(b) >= beats - 1;
        lines.forEach(function (l, i) {
          var delta = b - (i + 0.5);
          var a = Math.abs(delta);
          /* disjoint windows: a line is gone before the next may appear — overlap is impossible */
          var f = finale ? 0 : Math.max(0, Math.min(1, (0.48 - a) / 0.30));
          l.style.setProperty('--f', f.toFixed(3));
          l.style.setProperty('--dy', (delta * -24).toFixed(1) + 'px');
        });
        /* background rolls with the scroll — pure wash exactly at each line's centre */
        var t = Math.max(0, Math.min(washes.length - 1.001, b - 0.5));
        var wi = Math.floor(t);
        var fr = t - wi;
        fr = fr * fr * (3 - 2 * fr);
        var c0 = washes[wi], c1 = washes[wi + 1];
        if (rpin) rpin.style.backgroundColor = 'rgb(' +
          Math.round(c0[0] + (c1[0] - c0[0]) * fr) + ',' +
          Math.round(c0[1] + (c1[1] - c0[1]) * fr) + ',' +
          Math.round(c0[2] + (c1[2] - c0[2]) * fr) + ')';
        if (frames.length) {
          var nIntro = rsec.querySelectorAll('.dv-rintro').length;
          var idx = Math.min(frames.length - 1, Math.max(0, Math.floor(b) - Math.max(0, nIntro - 1)));
          frames.forEach(function (fr2, i) { fr2.classList.toggle('dv-cur', i === idx); });
        }
      };
      var storyFrame = function () {
        /* when scrolling pauses, the target becomes the nearest clean beat centre —
           users can never be left between two lines */
        var idle = (performance.now() - storyMove) > 150;
        var target = idle
          ? Math.min(beats - 0.5, Math.max(0.5, Math.round(rawB - 0.5) + 0.5))
          : rawB;
        curB += (target - curB) * 0.3;
        if (Math.abs(target - curB) < 0.004) curB = target;
        applyStory(curB);
        if (curB === target && idle) { storyRunning = false; return; }
        requestAnimationFrame(storyFrame);
      };
      var onStoryScroll = function () {
        measureStory();
        storyMove = performance.now();
        if (!storyRunning) { storyRunning = true; requestAnimationFrame(storyFrame); }
      };
      window.addEventListener('scroll', onStoryScroll, { passive: true });
      measureStory(); curB = rawB; applyStory(curB);


      /* tap a line to jump its beat into the spotlight */
      lines.forEach(function (l, i) {
        l.addEventListener('click', function () {
          var top = rstage.getBoundingClientRect().top + window.scrollY;
          var total = rstage.offsetHeight - window.innerHeight;
          window.scrollTo({ top: top + ((i + 0.5) / beats) * total, behavior: 'smooth' });
        });
      });
    }

    // petal rain runs the whole page; it dissolves when the colophon arrives
    var colo = document.querySelector('.dv-colophon');
    if (colo && document.querySelector('.dv-petal-layer')) {
      var petalIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          document.documentElement.classList.toggle('dv-nopetals', e.isIntersecting);
        });
      }, { threshold: 0.2 });
      petalIO.observe(colo);
    }

    // rails (mood + craft): angular coverflow — cards angle on the x-axis as
    // they slide and recede on the z-axis away from the rail centre
    document.querySelectorAll('.dv-rail').forEach(function (railEl) {
      if (rm) return;
      var railCards = railEl.querySelectorAll('.dv-archcard, .dv-ccard');
      if (!railCards.length) return;
      var railTick = false;
      var railTilt = function () {
        if (railTick) return;
        railTick = true;
        requestAnimationFrame(function () {
          railTick = false;
          var rr = railEl.getBoundingClientRect();
          var mid = rr.left + rr.width / 2;
          railCards.forEach(function (cd) {
            var r = cd.getBoundingClientRect();
            var d = (r.left + r.width / 2 - mid) / rr.width;
            d = Math.max(-0.9, Math.min(0.9, d));
            cd.style.setProperty('--tilt', (-d * 14).toFixed(2) + 'deg');
            cd.style.setProperty('--tsc', (1 - Math.abs(d) * 0.07).toFixed(3));
            cd.style.setProperty('--ad', Math.abs(d).toFixed(3));
          });
        });
      };
      railEl.addEventListener('scroll', railTilt, { passive: true });
      window.addEventListener('scroll', railTilt, { passive: true });
      railTilt();
    });

    // rails: one-time nudge hint on first sight (mobile only)
    if (!rm && window.innerWidth < 820) {
      document.querySelectorAll('.dv-rail').forEach(function (rail) {
        var nudged = false;
        var railIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !nudged) {
              nudged = true;
              setTimeout(function () { rail.scrollBy({ left: 34, behavior: 'smooth' }); }, 500);
              setTimeout(function () { rail.scrollBy({ left: -34, behavior: 'smooth' }); }, 1150);
              railIO.disconnect();
            }
          });
        }, { threshold: 0.35 });
        railIO.observe(rail);
      });
    }
  });
})();
